/* ============
 * Register Index Page
 * ============
 *
 * Page where the user can register
 */

import authService from "./../../../services/auth";
import mixin from "../../../mixins/mixin";
import { VueTelInput } from "vue-tel-input";

export default {
  data() {
    return {
      user: {
        full_name: null,
        first_name: "",
        last_name: "",
        email: "",
        password_confirmation: "",
        password: "",
        phone: "",
        twofa_request_id: "",
        twofa_code1: "",
        twofa_code2: "",
        twofa_code3: "",
        twofa_code4: "",
        twofa_code5: "",
        twofa_code6: "",
      },
      smallLoading: false,
      cguAccepted: true,
      showMobileText: false,
      twoFaByEmailModeEnabled: false,
      hiddenEmail: "********",
      hiddenPhone: "********",
    };
  },
  components: {
    VLoading: require("components/loading/loading.vue"),
    VInputPassword: require("components/password-input/VueInputPassword.vue"),
    VueTelInput,
  },
  watch: {
    "user.phone"(val, oldval) {
      var regExp = /[a-zA-Z\s]/g;
      if (regExp.test(val)) {
        this.user.phone = val.replace(regExp, "");
      }

      var phone = this.user.phone;
      this.hiddenPhone =
        phone.charAt(0) +
        phone.charAt(1) +
        "******" +
        phone.charAt(phone.length - 2) +
        phone.charAt(phone.length - 1);
    },

    "user.email"(val, oldval) {
      var email = this.user.email;
      this.hiddenEmail =
        email.charAt(0) +
        email.charAt(1) +
        "**********" +
        email.charAt(email.length - 4) +
        email.charAt(email.length - 3) +
        email.charAt(email.length - 2) +
        email.charAt(email.length - 1);
    },

    "user.twofa_code1"() {
      document.getElementById("twofa_code2").focus();
    },
    "user.twofa_code2"() {
      document.getElementById("twofa_code3").focus();
    },
    "user.twofa_code3"() {
      document.getElementById("twofa_code4").focus();
    },
    "user.twofa_code4"() {
      document.getElementById("twofa_code5").focus();
    },
    "user.twofa_code5"() {
      document.getElementById("twofa_code6").focus();
    },
  },

  mounted() {
    // window.location.href = "https://form.superhote.com/rejoindre";
    // if (!window.location.hash.includes("ahwoKyDvL4W28GUjmPYVmIQOcwMhtoFtOw29veG6HOX0PyEf")) {
    //   window.location.href = "https://form.superhote.com/rejoindre";
    // } else {
    //   document.querySelector(".big-container").style.display = "block";
    // }

    document.querySelector(".big-container").style.display = "block";
    if (window.matchMedia("(max-width: 1000px)").matches) {
      this.showMobileText = true;
    }
  },

  mixins: [mixin],

  methods: {
    async register(user) {
      this.smallLoading = true;
      if ($("input[name='referral']").val()) {
        user.referral_id = $("input[name='referral']").val();
      }
      this.twoFaByEmailModeEnabled = false;
      await authService.register(user, this);

      if (this.user.twofa_request_id !== "") {
        this.openregister2faModal();
      }
    },

    async resend2faCode() {
      this.smallLoading = true;
      this.user.twofa_code = "";
      this.user.twofa_code1 = "";
      this.user.twofa_code2 = "";
      this.user.twofa_code3 = "";
      this.user.twofa_code4 = "";
      this.user.twofa_code5 = "";
      this.user.twofa_code6 = "";

      if (this.twoFaByEmailModeEnabled)
        await authService.resend2faCodeByEmail(this.user, this);
      else await authService.resend2faCodeBySms(this.user, this);
    },

    async confirm2faCode() {
      this.smallLoading = true;

      if (this.user.twofa_request_id !== null) {
        this.user.twofa_code =
          this.user.twofa_code1 +
          this.user.twofa_code2 +
          this.user.twofa_code3 +
          this.user.twofa_code4 +
          this.user.twofa_code5 +
          this.user.twofa_code6;

        if (this.twoFaByEmailModeEnabled)
          await authService.confirm2faCodeByEmail(this.user, this);
        else await authService.confirm2faCodeBySms(this.user, this);
      }
    },

    openregister2faModal() {
      this.openModal("#register-2fa-modal");
      this.user.twofa_code = "";
    },

    closeregister2faModal() {
      this.closeModal("#register-2fa-modal");
      this.user.twofa_code = "";
    },

    modify2faMode() {
      this.user.twofa_code = "";
      this.user.twofa_code1 = "";
      this.user.twofa_code2 = "";
      this.user.twofa_code3 = "";
      this.user.twofa_code4 = "";
      this.user.twofa_code5 = "";
      this.user.twofa_code6 = "";
      this.twoFaByEmailModeEnabled = !this.twoFaByEmailModeEnabled;

      this.smallLoading = true;
      if (this.twoFaByEmailModeEnabled)
        authService.resend2faCodeByEmail(this.user, this);
      else authService.resend2faCodeBySms(this.user, this);
    },

    acceptCGU() {
      this.cguAccepted = !this.cguAccepted;
    },

    handleBackspaceKey(twofaInputId) {
      document.getElementById("twofa_code" + (twofaInputId - 1)).focus();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/register/index/index.js